; (function () {
	"use strict";
	function PostsGridCards() {
		var global = {
			cards: false
		};

		var fn = {
			init: function () {
				fn.setupCards();
				fn.bindResize(); // listen to window resize
			},

			setupCards: function() {
				var cardGrids = jQuery('.posts-grid .posts-grid__grid');

				if (!cardGrids.length) {
					return;
				}

				var windowWidth = jQuery(window).width();
				if (windowWidth < 800) {
					// Clear heights when switching back to desktop
					cardGrids.each(function(i, cardGrid) {
						jQuery(cardGrid).find('.posts-grid-card__title, .posts-grid-card__excerpt').css('min-height', '');
					});
					return;
				}

				cardGrids.each(function(i, cardGrid) {
					global.cards = jQuery(cardGrid).find('.posts-grid-card__content');
					fn.equaliseHeights(global.cards);
				});
			},

			equaliseHeights: function(row) {
				var titles = jQuery(row).find('.posts-grid-card__title');
				var teasers = jQuery(row).find('.posts-grid-card__excerpt');
				var elementGroups = [titles, teasers];

				jQuery(elementGroups).each(function(i, elementGroup) {
					// Clear heights
					elementGroup.each(function(i, element) {
						jQuery(element).css('min-height', '');
					});

					var largestElement = fn.getLargestHeight(elementGroup);

					elementGroup.each(function(i, element) {
						jQuery(element).css('min-height', largestElement);
					});
				});
			},

			getLargestHeight: function(elems)
			{
				var largest = 0;
				elems.each(function(i, elem) {
					var elemHeight = jQuery(elem).height();
					if (elemHeight > largest)
					{
						largest = elemHeight;
					}
				});

				return largest;
			},

			bindResize: function() {
				jQuery(window).on('resize orientationchange', function() {
					fn.setupCards(); // re-run on resize/orientation change
				});
			}

		}
		jQuery(document).ready(fn.init);
	}
	new PostsGridCards();
})();